import { Type } from "class-transformer";
import { MetricDto } from "@/core/features/metrics/metric.dto";
import { WarehouseConsumableDto } from "@/core/features/warehouse-consumable/warehouse-consumable.dto";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { CategoryDto } from "@/core/features/categories/category.dto";

import { SubcategoryDto } from "@/core/features/subcategories/subcategory.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { ConsumableHasExternalReferenceDto } from "@/core/features/consumables-have-external-references/consumable-has-external-reference.dto";

export class ConsumableDto extends BaseEntityDto {
  name: string;

  reference: string;

  externalCode: string;

  @Type(() => MetricDto)
  metric: MetricDto;
  metricId: string;

  @Type(() => WarehouseConsumableDto)
  warehouseConsumables?: WarehouseConsumableDto[];

  @Type(() => ConsumableHasExternalReferenceDto)
  externalReferences?: ConsumableHasExternalReferenceDto[];

  @Type(() => CategoryDto)
  category: CategoryDto;
  categoryId: string;

  @Type(() => SubcategoryDto)
  subcategory: SubcategoryDto;
  subcategoryId: string;

  @Type(() => Number)
  minimumStock: number;

  qrCode?: string;

  @Type(() => UserDto)
  updatedBy?: UserDto;

  @Type(() => UserDto)
  createdBy: UserDto;

  archived: boolean;

  isRepair: boolean;

  repairConsumableId?: string;

  @Type(() => ConsumableDto)
  repairConsumable?: ConsumableDto;

  toString(): string {
    return `${this.name} - Ref. ${this.reference}`;
  }

  getExternalReferences() {
    return this.externalReferences?.length
      ? this.externalReferences.map((externalRef) => externalRef.externalReference).join(", ")
      : "-";
  }
}
